export default class ResponsiveNavbarItemsList {
    private navbarContainer: HTMLElement;
    private dropdownList: JQuery;
    private navbarItemsList: JQuery;

    private moreDropdown: JQuery;
    private showMoreButton: JQuery;
    private navbarContainerJq: JQuery<HTMLElement>;

    constructor() {
        this.initTargetElements();
    }

    private initTargetElements(): void {
        this.navbarContainerJq = jq(".navbar-items");

        this.moreDropdown = jq(".more-dropdown");
        this.showMoreButton = jq(".more-dropdown-button");

        this.navbarContainer = this.navbarContainerJq.get(0);
        this.navbarItemsList = this.navbarContainerJq.children(".nav-item:not(.mobile-view-container), .is-nested").not(this.showMoreButton);
        this.dropdownList = jq(".dropdown-menu-items");
    }

    public init(attachResizeEvent: boolean = true): void {
        if (attachResizeEvent) {
            const jqWindow: JQuery<Window> = jq(window as any);
            jqWindow.on("resize", () => {
                this.clearHiddenElements();
                this.updateListDropdown();
            });
        }
        this.clearHiddenElements();
        this.updateListDropdown();
        this.navbarContainerJq.removeClass("overflow-hidden");
    }

    public reinit(): void {
        this.initTargetElements();
        this.init(false);
    }

    private updateListDropdown(): void {

        if (typeof this.navbarContainer === "undefined") {
            return;
        }

        // For calculation used native javascript OffsetTop instead of jquery .offset().top
        // since in some cases jquery solution returns unexpected values and caused menu to break
        const navbarOffsetTop = this.navbarContainer.offsetTop;
        this.dropdownList.empty();
        let i = this.navbarItemsList.length - 1;
        while (i >= 0 && this.moreDropdown.get(0).offsetTop > navbarOffsetTop) {
            const listItemJq = jq(this.navbarItemsList.get(i));
            if (listItemJq.hasClass("is-nested")) { // contains sub-items
                const clonedItem = listItemJq.next(".mobile-item-wrapper").first().clone();
                this.dropdownList.prepend(clonedItem.contents());
            } else {
                const clonedItem = listItemJq.clone();
                this.dropdownList.prepend(clonedItem);
            }
            listItemJq.addClass("hidden");
            i--;
        }

        this.toggleDropdownButtonVisibility();
    }

    private toggleDropdownButtonVisibility(): void {
        if (this.dropdownList.is(":empty")) {
            this.showMoreButton.hide();
            this.showMoreButton.css("visibility", "hidden");
        } else {
            this.showMoreButton.show();
            this.showMoreButton.css("visibility", "visible");

            this.dropdownList.show();
            const dropdownListWidth = this.dropdownList.width();
            this.dropdownList.removeAttr("style");
            if (this.moreDropdown.position().left > dropdownListWidth) {
                this.dropdownList.addClass("dropdown-menu-end");
            } else {
                this.dropdownList.removeClass("dropdown-menu-end");
            }

        }
    }

    private clearHiddenElements(): void {
        this.navbarItemsList.removeClass("hidden");
    }
}
